import React from "react";

export default function PresetList(props) {

  return (
    <ul className="fk-table__list">
      {props.children}
    </ul>
  );
}